/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState } from "react";
import { track } from "jiffy-analytics";
import { dtfStore } from "../react-product-details-dtf/store";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import ArtworkFeedbackModal from "./ArtworkFeedbackModal.vue";
import { cn } from "tailwind-variants";
import "./ArtworkEnhancementFeedback.scss";

export default function ArtworkEnhancementFeedback({ artwork, pageType, ...restProps }: any) {
  const store = dtfStore;
  const [satisfied, setSatisfied] = useState(artwork.enhancementSatisfied);
  const [showThankYou, setShowThankYou] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);

  function handleThumbsUp() {
    markFeedbackSubmitted(true, true);
    triggerTracking("dtf_satisfaction_positive_clicked", {
      artworkId: artwork.id,
      pageType
    });
  }

  function handleThumbsDown() {
    if (artwork.enhancementRatingSubmitted) {
      return;
    }
    // Track the thumbs down click
    triggerTracking("dtf_satisfaction_negative_clicked", {
      artworkId: artwork.id,
      pageType
    });
    // Show the feedback modal
    setShowFeedbackModal(true);
  }

  function handleFeedbackModalSubmit(selectedReason: any) {
    markFeedbackSubmitted(true, false);
    // Track the feedback submission with the selected reason
    triggerTracking("dtf_satisfaction_feedback", {
      artworkId: artwork.id,
      message: selectedReason,
      // Using the selected reason as the message
      pageType
    });
    setShowFeedbackModal(false);
  }

  function handleFeedbackModalClose() {
    setShowFeedbackModal(false);
    // Reset to neutral state since user cancelled without providing feedback
    setSatisfied(null);
  }

  async function triggerTracking(event: any, payload: any) {
    track(event, payload);
  }

  function markFeedbackSubmitted(feedbackSubmitted: any, isSatisfied: any) {
    store.updateArtworkValuesById({
      id: artwork.id,
      enhancementFeedbackSubmitted: feedbackSubmitted,
      enhancementRatingSubmitted: true,
      enhancementSatisfied: isSatisfied
    });
    setSatisfied(isSatisfied);
    setShowThankYou(!!(isSatisfied || feedbackSubmitted));
  }

  return (
    <div {...restProps} className={cn("artwork-feedback scope-3f92dd41", restProps.className)}>
      {showThankYou ||
      (artwork.enhancementFeedbackSubmitted && artwork.enhancementRatingSubmitted) ? (
        <div className="artwork-feedback__thankyou scope-3f92dd41">
          <UseSvg
            class="scope-3f92dd41"
            icon="check-circle-primary"
            width="24"
            height="24"
            data-testid="use-svg"
          />
          <span className="scope-3f92dd41">Thank you for your feedback!</span>
        </div>
      ) : !showFeedbackModal ? (
        <div className="artwork-feedback__header scope-3f92dd41">
          <div className="artwork-feedback__question scope-3f92dd41">Happy with your image?</div>
          <div className="artwork-feedback__actions scope-3f92dd41">
            <button
              className="artwork-feedback__thumb artwork-feedback__thumb-positive scope-3f92dd41"
              type="button"
              aria-label="Satisfied"
              disabled={artwork.enhancementRatingSubmitted}
              onClick={e => {
                e.preventDefault();
                // @ts-expect-error TS migration
                handleThumbsUp(e);
              }}
              data-testid="artwork-feedback-thumb"
            >
              <span className="artwork-feedback__thumb-positive-icon-container scope-3f92dd41">
                <UseSvg
                  class="scope-3f92dd41"
                  icon="thumbs-up-green"
                  width="24"
                  height="24"
                  data-testid="use-svg-1"
                />
              </span>
            </button>
            <button
              className={cn(
                "scope-3f92dd41",
                "artwork-feedback__thumb artwork-feedback__thumb-negative",
                satisfied === false && "artwork-feedback__thumb-negative--active"
              )}
              type="button"
              aria-label="Not satisfied"
              onClick={e => {
                e.preventDefault();
                // @ts-expect-error TS migration
                handleThumbsDown(e);
              }}
              data-testid="artwork-enhancement-feedback-button"
            >
              <span className="artwork-feedback__thumb-negative-icon-container scope-3f92dd41">
                <UseSvg
                  class="artwork-feedback__thumb-negative-icon scope-3f92dd41"
                  icon="thumbs-down"
                  width="24"
                  height="24"
                  data-testid="artwork-feedback-thumb-negative-icon"
                />
              </span>
            </button>
          </div>
        </div>
      ) : null}
      {showFeedbackModal ? (
        <ArtworkFeedbackModal
          class="scope-3f92dd41"
          onSubmit={handleFeedbackModalSubmit}
          onClose={handleFeedbackModalClose}
          data-testid="artwork-feedback-modal"
        />
      ) : null}
    </div>
  );
}
